import LceCourseExperienceExperiments from 'bundles/epic/clients/LceCourseExperience';

export const isAdaptiveLearningEnabled = (courseId: string): boolean => {
  return LceCourseExperienceExperiments.get('isAdaptiveLearningEnabled', { course_id: courseId });
};
